import { Typography } from '@navi/web-ui/lib/primitives';
import { getQuestionText } from './utils';
import { IFeedbackDetailImageItem } from '../interfaces';

const AddressFeedbackDetailImage = (props: IFeedbackDetailImageItem) => {
  const { image } = props;
  const questionText = getQuestionText(image);
  const originalImageUri = image?.metadata?.originalDocumentSignedUri || image?.inputText;

  return (
    <div className="mb-4">
      <Typography variant="h5" color="var(--grayscale-content-3)" className="mb-2">
        {questionText}
      </Typography>
      <img
        alt="Feedback-Image"
        src={originalImageUri as string}
        key={originalImageUri as string}
        className={'w-[200px] h-[300px] object-cover object-bottom rounded-md'}
      />
    </div>
  );
};

export default AddressFeedbackDetailImage;
